export function zeroPad(val: number, minSize: number = 2): string {
  let calculatedResult = val.toString();

  if (calculatedResult.length >= minSize) {
    return calculatedResult;
  }

  while (calculatedResult.length < minSize) {
    calculatedResult = `0${calculatedResult}`;
  }

  return calculatedResult;
}
